import React from 'react';
import { LeafIcon, HeartIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
const pillars = [{
  icon: <LeafIcon size={32} className="text-sage" data-id="element-204" />,
  title: 'Alimentación Inteligente',
  desc: 'Aprenderás a combinar alimentos para mantener la insulina estable y quemar grasa naturalmente, sin contar calorías.'
}, {
  icon: <HeartIcon size={32} className="text-coral" data-id="element-205" />,
  title: 'Desinflamación Natural',
  desc: 'Eliminaremos los alimentos que te hinchan en secreto y agregaremos los que sanan tu intestino.'
}, {
  icon: <ZapIcon size={32} className="text-warm-brown" data-id="element-206" />,
  title: 'Hábitos Sostenibles',
  desc: 'Rutinas simples que se adaptan a tu vida ocupada, para que los resultados duren para siempre.'
}];
export function SolutionSection() {
  return <section className="py-20 bg-gradient-to-b from-white to-beige/30" data-id="element-207">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-208">
        <div className="text-center mb-16" data-id="element-209">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-210">
            La Solución Definitiva
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-text-dark mb-4" data-id="element-211">
            Presentamos:{' '}
            <span className="text-coral" data-id="element-212">Reinicia tu Metabolismo</span> en 21
            Días
          </h2>
          <p className="text-xl text-text-medium max-w-2xl mx-auto" data-id="element-213">
            El método paso a paso que transforma tu cuerpo desde adentro,
            sanando tu metabolismo en lugar de castigarlo.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 mb-16" data-id="element-214">
          {/* CSS Book Mockup */}
          <div className="lg:w-1/2 flex justify-center perspective-1000" data-id="element-215">
            <div className="relative w-64 h-80 md:w-80 md:h-96 animate-float" data-id="element-216">
              {/* Book Shadow */}
              <div className="absolute -bottom-4 left-4 right-4 h-8 bg-black/20 blur-xl rounded-full" data-id="element-217"></div>

              {/* Book Cover */}
              <div className="absolute inset-0 bg-gradient-to-br from-coral to-rose rounded-r-2xl rounded-l-sm shadow-2xl transform rotate-y-[-15deg] rotate-x-[5deg] transform-style-3d border-l-8 border-coral-dark overflow-hidden flex flex-col" data-id="element-218">
                <div className="p-6 text-white flex-1 flex flex-col" data-id="element-219">
                  <div className="w-12 h-1 bg-white/50 mb-6" data-id="element-220"></div>
                  <h3 className="text-2xl md:text-3xl font-black leading-tight mb-2" data-id="element-221">
                    REINICIA TU METABOLISMO
                  </h3>
                  <p className="text-white/90 font-medium mb-auto" data-id="element-222">
                    EN 21 DÍAS
                  </p>

                  <div className="mt-auto" data-id="element-223">
                    <div className="flex items-center gap-2 mb-4" data-id="element-224">
                      <span className="bg-white/20 px-2 py-1 rounded text-xs font-bold backdrop-blur-sm" data-id="element-225">
                        MÉTODO COMPROBADO
                      </span>
                    </div>
                    <p className="text-sm text-white/80 border-t border-white/20 pt-4" data-id="element-226">
                      La guía definitiva para desinflamar y bajar de peso
                      naturalmente.
                    </p>
                  </div>
                </div>

                {/* Book spine effect */}
                <div className="absolute top-0 bottom-0 left-0 w-2 bg-black/10" data-id="element-227"></div>
                <div className="absolute top-0 bottom-0 left-2 w-px bg-white/30" data-id="element-228"></div>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 space-y-8" data-id="element-229">
            {pillars.map((pillar, index) => <div key={index} className="flex bg-white p-6 rounded-2xl shadow-soft border border-beige-dark/50" data-id="element-230">
                <div className="flex-shrink-0 mr-4 bg-bg-warm p-3 rounded-xl h-fit" data-id="element-231">
                  {pillar.icon}
                </div>
                <div data-id="element-232">
                  <h4 className="text-xl font-bold text-text-dark mb-2" data-id="element-233">
                    {pillar.title}
                  </h4>
                  <p className="text-text-medium" data-id="element-234">{pillar.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-235">
          <a href="https://reiniciatumetabolismo.lat/cart/43809396064391:1?checkout" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-coral rounded-full shadow-cta hover:bg-coral-dark transition-all duration-300 w-full sm:w-auto" data-id="element-236">
            Quiero empezar mi transformación
            <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={24} data-id="element-237" />
          </a>
          <p className="text-sm text-text-medium mt-4 font-medium" data-id="element-238">
            Empezá hoy y sentí el cambio en solo 7 días 💪
          </p>
        </div>
      </div>
    </section>;
}